<template lang="pug">
    .about-whatwedo
        .about-whatwedo-title
            | {{ lenguageSelected.title }}
        p {{ lenguageSelected.content1 }}
        p {{ lenguageSelected.content2 }}

</template>

<script>
export default {
    props: ["lang"],
    created: function(){
        this.$data.lenguage = this.lang
        console.log(this.lang)
    },
    data: function(){
        return {
            lenguage: 'EN',
            lenguageEN: {
                title: 'Enabling Mobile and Internet Connectivity.',
                content1: 'ATP is an independent, privately owned provider of digital infrastructure. Our portfolio comprises thousands of owned and managed sites across Colombia, Peru, Chile and Ecuador.',
                content2: 'As a leading telecommunications infrastructure company supporting the Andean region’s vibrant digital economy, our solutions play a central role in enabling mobile and internet connectivity in South America.'
            },
            lenguageES: {
                title: 'Habilitamos las Conexiones Digitales',
                content1: 'ATP es una empresa privada e independiente que provee servicios de infraestructura digital. Nuestro portafolio de activos incluye miles de sitios administrados entre Colombia, Perú, Chile y Ecuador.',
                content2: 'Somos una empresa líder en infraestructura de telecomunicaciones que respalda la dinámica economía digital en la región andina. Nuestras soluciones desempeñan un papel central en los servicios de conectividad en América del Sur.'
            },
        }
    },
    computed: {
        lenguageSelected: function(){
            return this.$data.lenguage == 'EN'? this.$data.lenguageEN : this.$data.lenguageES
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/molecules/PmWhatWeDo.vue